import * as React from 'react'

export const Form = ({ input }) => {
  const props = input.get('props')
  return (
    <div>
      <h2 className="pt-heading">{props.get('label')}</h2>
    </div>
  )
}

export const Configuration = () => {
  return <div />
}
